import {CommandBase} from '@shared/commands/command-base';
import {Configuration} from '@shared/models/configuration';

export class CreateSubAccountCommand extends CommandBase {
  constructor(public accountName: string, public description: string) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/CreateSubAccount`);
  }
}
export class AddUserToSubAccountCommand extends CommandBase {
  constructor(public accountId: string,
              public firstName: string,
              public lastName: string,
              public email: string,
              public phone: string,
              public title: string,
              public message: string,
              public packages: any[]
  ) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/CreateSubAccountUser`);
  }
}

export class DeleteSubAccountCommand extends CommandBase {
  constructor(public subAccountIds: string[]) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/DeleteSubAccount`);
  }
}

export class UpdateSubAccountUserStatusCommand extends CommandBase {
  constructor(public subAccountUserId: string,
              public userStatus: string) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/UpdateSubAccountUserStatus`);
  }
}

export class EnableSubAccountUserCommand extends CommandBase {
  constructor(public subAccountUserId: string) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/EnableSubAccountUser`);
  }
}

export class SendConfirmationEmailCommand extends CommandBase {
  constructor(public subAccountUserId: string) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/SendConfirmationEmail`);
  }
}

export class EditSubAccountUserPackagesCommand extends CommandBase {
  constructor(public subAccountUserId: string,
              public packages: string[]) {
    super(`${Configuration.getConfig('AdminPanelApi')}Command/EditSubAccountUserPackages`);
  }
}
